import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UIKitBaseComponent } from '@macs-frontend/features';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-svg-pack',
  templateUrl: './svg-pack.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgPackComponent extends UIKitBaseComponent {}
